export enum CarouselPresentationStyle {
    PROMINENT = 'prominent',
    DEFAULT = 'default',
    BRAND = 'brand',
    DISPLAY_AD_BANNER = 'display-ad-banner',
    GRID = 'grid',
    NUMERIC = 'default_numeric',
    SPOTLIGHT = 'spotlight',
    SPOTLIGHT_MARQUEE = 'spotlight_marquee',
    SPOTLIGHT_MARQUEE_169 = 'spotlight_marquee_16x9',
    CAROUSEL_16x9 = 'carousel_16x9',
}
